module.exports = __webpack_public_path__ + "static/media/socialPiper-post-tabletPro-en.b4628dae.png";